import { z } from "zod";
import { VARIATION_CREATIVITY_STRENGTH_PRESETS } from "../../../Board/Workspaces/EditWorkspace/Tools/EditAsset/Variation/constants.ts";
import { settingsStorageFactory } from "./settingsStorageFactory.ts";

const zVariationSettings = z.object({
  prompt: z.string().default(""),
  num_generations: z.number().default(4),
  prompt_strength: z.number().default(0.5),
  creativity_strength_preset: z
    .enum(VARIATION_CREATIVITY_STRENGTH_PRESETS)
    .default("MEDIUM"),
  guidance_scale: z.number().default(0.5),
});

export const variationSettingsStorage = settingsStorageFactory(
  "variation-settings",
  2,
  zVariationSettings,
);
